import Cookies from "js-cookie";

import { Track } from "@/src/lib/tracking";
import {
  AD_LINK_OPEN_EVENT,
  AD_LINK_PARAMS_COOKIE_KEY,
  AD_LINK_RESOLVE_VIA_PROXY,
  parseAdLinkParamsCookie,
} from "./adLinkOpen";

/**
 * 读出 Proxy 暂存的（已脱敏）广告链接参数 → 上报 `ad_link_open` → 删 cookie（一次性）。
 *
 * 先删再发：同一个 cookie 被两次读到（多个 effect / 路由切换）也只报一次。
 */
export function consumeAdLinkOpenCookie(): void {
  if (typeof document === "undefined") {
    return;
  }
  const raw = Cookies.get(AD_LINK_PARAMS_COOKIE_KEY);
  if (raw === undefined) {
    return;
  }
  Cookies.remove(AD_LINK_PARAMS_COOKIE_KEY, { path: "/" });
  const params = parseAdLinkParamsCookie(raw);
  if (Object.keys(params).length === 0) {
    return;
  }
  // key 写字面量（= AD_LINK_RESOLVE_VIA_KEY）：事件总表生成器靠静态扫描，计算属性扫不出来；两者相等由单测钉住
  Track.event(AD_LINK_OPEN_EVENT, {
    ...params,
    resolve_via: AD_LINK_RESOLVE_VIA_PROXY,
  });
}
